import { z } from 'zod';

export const UserTeamUpsertModalSchema = z.object({
  name: z.string().min(1, "チーム名を入力してください").max(120, "チーム名は120文字以内で入力してください"),
});

export type UserTeamUpsertModalData = z.infer<typeof UserTeamUpsertModalSchema>;
